<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-06 15:35:08
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 15:35:09
-->
<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:15
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="商标申请">
        <!-- <div class="tool-box">
          <a-button @click="handleAdd" type="primary">新增</a-button>
        </div> -->
        <a-table :data-source="data" :columns="columns" rowKey="id" style="width: 100%">
          <span slot="pattern" slot-scope="text">{{ text == 0 ? "黑白" : "着色" }}</span>
          <span slot="agencyzId" slot-scope="text">{{ fmtAgency(text) }}</span>
          <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
          <template slot="operation" slot-scope="text, record">
            <a
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleDetail(record)"
              >详情</a
            >
            <!--<a
              v-if="iszhuang"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handestatus(record)"
              >{{
                record.status == 0
                  ? "提交资料中"
                  : record.status == 1
                  ? "等待商标审核"
                  : record.status == 2
                  ? "提交商标局"
                  : "申请成功"
              }}</a
            >-->
            <a
              v-if="userInfo && userInfo.type != '代理机构'"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEdit(record)"
              >修改</a
            >
                 <a
              v-if="userInfo && userInfo.type == '代理机构'"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEditStatus(record)"
              >修改状态</a
            >
            <a-popconfirm
              v-if="userInfo && userInfo.type != '代理机构'"
              title="请确认是否删除?"
              @confirm="() => onDelete(record)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="title"
      :visible="visible"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model v-model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
        <a-form-model-item label="商标名称">
          <a-input v-if="isEdit" v-model="form.trademarkName" :disabled="!isEdit" />
          <span v-else>{{ form.trademarkName }}</span>
        </a-form-model-item>
        <a-form-model-item label="商标说明">
          <a-input v-if="isEdit" v-model="form.trademarkDesc" :disabled="!isEdit" />
          <span v-else>{{ form.trademarkDesc }}</span>
        </a-form-model-item>
        <a-form-model-item label="代理委托书">
          <a-upload
            :showUploadList="false"
            :locale="locale"
            name="file"
            action="/newapp/api/common/attachment/"
            @change="handleChangeA"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>
          <a
            v-if="form.attorneyPower"
            :href="'/app/common/attachment?id=' + form.attorneyPower"
            >下载</a
          >
          <!-- <viewer v-if="form.attorneyPower">
            <img
              :src="'/app/common/attachment?id=' + form.attorneyPower"
              style="margin: 8px; cursor: pointer"
              width="100%"
              height="100"
            />
          </viewer> -->
        </a-form-model-item>
        <a-form-model-item label="商标图样">
          <a-select v-if="isEdit" v-model="form.pattern" :disabled="!isEdit">
            <a-select-option :value="0"> 黑白 </a-select-option>
            <a-select-option :value="1"> 着色 </a-select-option>
          </a-select>
          <span v-else>{{ ["黑白", "着色"][form.pattern] }}</span>
        </a-form-model-item>
        <a-form-model-item label="商标分类">
          <a-select
            v-if="isEdit"
            v-model="form.trademarkClassify"
            mode="multiple"
            :disabled="!isEdit"
          >
            <a-select-option v-for="item in type" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ form.trademarkClassify }}</span>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-if="isEditStatus" v-model="form.status" :disabled="!isEditStatus">
            <a-select-option v-for="(item, index) in status" :key="item" :value="index">
              {{ item }}
            </a-select-option>
          </a-select>
          <span v-else>{{ status[form.status] }}</span>
        </a-form-model-item>
        <!--<a-form-model-item label="代理机构">
          <a-select v-if="isEdit" v-model="form.agencyzId" :disabled="!isEdit">
            <a-select-option v-for="item in org" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ fmtAgency(form.agencyzId) }}</span>
        </a-form-model-item>-->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "商标名称",
    dataIndex: "trademarkName",
    key: "trademarkName",
    width: 120,
    ellipsis: true,
  },
  {
    title: "商标说明",
    dataIndex: "trademarkDesc",
    key: "trademarkDesc",
    width: 120,
    ellipsis: true,
  },
  {
    title: "商标图样",
    dataIndex: "pattern",
    key: "pattern",
    scopedSlots: { customRender: "pattern" },
    width: 120,
    ellipsis: true,
  },
  {
    title: "商标分类",
    dataIndex: "trademarkClassify",
    key: "trademarkClassify",
    width: 120,
    ellipsis: true,
  },
  {
    title: "代理机构",
    dataIndex: "agencyzId",
    key: "agencyzId",
    ellipsis: true,
  },
  {
    title: "商标状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width:180,
    ellipsis: true,

  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
  },
];
import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "user-center-brand",
  data() {
    return {
      locale,
      iszhuang: false,
      data: [],
      columns,
      type: [],
      org: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      confirmLoading: false,
      isEdit: false,
      isEditStatus: false,
      isEditFlag: false,
      parents: [],
      form: {},
      status: ["提交资料中", "等待商标审核", "提交商标局", "申请成功","申请失败"],
      userInfo: {},
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");

    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      console.log(this.userInfo.type);
      if (this.userInfo.type == "代理机构") {
        this.iszhuang = true;
      }
      console.log(this.userInfo.menuVOS);
    }

    this.queryList();
    this.queryDict();
    // this.queryOrg();
  },
  methods: {
    handleChangeA(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        console.log(info);
        this.form.attorneyPower = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    fmtStatus(text) {
      if (text == 0) {
        return "提交资料中";
      } else if (text == 1) {
        return "等待商标审核";
      } else if (text == 2) {
        return "提交商标局";
      } else if (text == 3) {
        return "申请成功";
      } else if (text == 4) {
        return "申请失败";
      }
    },
    handleDetail(record) {
      // this.form = record;
      request({
        url: `/api/center/order/trademarkregister/${record.id}`,
      }).then((res) => {
        this.visible = true;
        this.title = "详情";
        this.isEdit = false;
         this.isEditStatus = false;
        this.form = res.data;
      });
    },
    onDelete(record) {
      request({
        url: "/api/center/order/trademarkregister/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },
    handleEdit(record) {
      this.visible = true;
      this.title = "修改";
      request({
        url:"/api/center/order/trademarkregister/"+record.id,
        method:"get"
      }).then(res=>{
         this.form = res.data
        //  this.form.trademarkClassify=[{trademarkClassify:1},{trademarkClassify:2}];
      })
      // this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = true;
      this.isEditStatus = false;
      this.queryDict();
      
    },
    handleEditStatus(record) {
      this.visible = true;
      this.title = "修改";
      request({
        url:"/api/center/order/trademarkregister/"+record.id,
        method:"get"
      }).then(res=>{
         this.form = res.data
      })
      // this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = false;
      this.isEditStatus = true;
    },
    handleAdd() {
      this.isEdit = true;
      this.isEditStatus = false;
      this.title = "新增";
      this.visible = true;
      this.form = {};
    },
    handestatus(record) {
      const params = { id: record.id, status: "" };
      if (record.status == 0) {
        params.status = 1;
      }
      if (record.status == 1) {
        params.status = 2;
      }
      if (record.status == 2) {
        params.status = 3;
      }

      request({
        url: "/api/center/order/trademarkregister",
        method: "put",
        params,
      }).then((res) => {
        if (res.msg == "success") {
          this.$message.info("操作成功");
          this.visible = false;
          this.form = {};
          this.queryList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleOk() {
      const params = Object.assign({}, this.form);
       if(this.isEditStatus==false&&this.isEdit==true){
          this.isEditFlag=true;
      }
       if(this.isEditStatus==true&&this.isEdit==false){
          this.isEditFlag=true;
      }
      if (this.isEditFlag) {
        request({
          url: "/api/center/order/trademarkregister",
          method: this.title == "修改" ? "put" : "post",
          params,
        }).then((res) => {
          if (res.msg == "success") {
            this.$message.info("操作成功");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible = false;
        this.form = {};
      }
    },
    fmttype(text) {
      const result = this.type.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    fmtAgency(text) {
      console.log(text)
      const result = this.org.find((ele) => ele.key == text);
            console.log(result)
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        console.log("dict", res);
         if (res.code == "200") {
         this.type = res.data;
        }
      });
    },

    queryOrg() {
      request({
       url: "/api/client/common/select/enterprise/list?key=ORG_OWNER",
      }).then((res) => {
        this.org = res.data;
      });
    },
    queryList() {
      request({
        url: "/api/center/order/trademarkregister/list",
        params: this.page,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
  },
};
</script>

<style lang="less"></style>
